module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "inviter"
  }, [_vm._v("好友邀请")]), _vm._v(" "), _c('div', {
    staticClass: "remainder"
  }, [_c('p', {
    staticClass: "remainderChild"
  }, [_vm._v("我的余额"), _c('i', [_vm._v("￥")]), _c('span', [_vm._v(_vm._s(_vm.total))])]), _vm._v(" "), _c('p', {
    staticClass: "seeDetail",
    on: {
      "click": _vm.seeDetail
    }
  }, [_vm._v("查看明细")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((_vm.invite), function(invites) {
    return _c('div', {
      staticClass: "dateList"
    }, [_c('div', {
      staticClass: "datesList"
    }, [_vm._v(_vm._s(invites.date))]), _vm._v(" "), _c('div', {
      staticClass: "incomeList"
    }, [_vm._v(_vm._s(invites.value))]), _vm._v(" "), _c('div', {
      staticClass: "detailInfoList"
    }, [_vm._v(_vm._s(invites.remark))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scancode"
  }, [_c('img', {
    staticClass: "QRcode",
    attrs: {
      "src": require("../../assets/soamaa.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wholeBalance"
  }, [_c('div', {
    staticClass: "wholeword"
  }, [_vm._v("全部")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detailList"
  }, [_c('div', {
    staticClass: "dates"
  }, [_vm._v("日期")]), _vm._v(" "), _c('div', {
    staticClass: "income"
  }, [_vm._v("收入/支出")]), _vm._v(" "), _c('div', {
    staticClass: "detailInfo"
  }, [_vm._v("详细信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1ada060","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orderList/Invite.vue
// module id = 562
// module chunks = 1